<form
  class="form-b4a payment-response-message-type-form"
  [class.editable]="paymentResponseMessageType"
  [formGroup]="form"
  *ngIf="form"
  (submit)="savePaymentResponseMessageType()"
>
  <span class="p-float-label">
    <input
      id="typeContent"
      type="text"
      pInputText
      formControlName="typeContent"
    /><label for="typeContent"> Título </label>
    <small
      class="error"
      *ngIf="
        form.controls['typeContent'].errors &&
        form.controls['typeContent'].errors['maxlength']
      "
    >
      Máximo de
      {{ form.controls['typeContent'].errors['maxlength']['requiredLength'] }}
      caracteres
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['typeContent'].errors &&
        form.controls['typeContent'].errors['minlength']
      "
    >
      Mínimo de
      {{ form.controls['typeContent'].errors['minlength']['requiredLength'] }}
      caracteres
    </small>
  </span>
  <span class="p-float-label">
    <input
      id="messageContent"
      type="text"
      pInputText
      formControlName="messageContent"
    /><label for="messageContent"> Texto da resposta </label>
    <small
      class="error"
      *ngIf="
        form.controls['messageContent'].errors &&
        form.controls['messageContent'].errors['maxlength']
      "
    >
      Máximo de
      {{
        form.controls['messageContent'].errors['maxlength']['requiredLength']
      }}
      caracteres
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['messageContent'].errors &&
        form.controls['messageContent'].errors['minlength']
      "
    >
      Mínimo de
      {{
        form.controls['messageContent'].errors['minlength']['requiredLength']
      }}
      caracteres
    </small>
  </span>
  <span class="p-float-label">
    <input
      id="buttonText"
      type="text"
      pInputText
      formControlName="buttonText"
    /><label for="buttonText"> Texto do botão </label>
    <small
      class="error"
      *ngIf="
        form.controls['buttonText'].errors &&
        form.controls['buttonText'].errors['maxlength']
      "
    >
      Máximo de
      {{ form.controls['buttonText'].errors['maxlength']['requiredLength'] }}
      caracteres
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['buttonText'].errors &&
        form.controls['buttonText'].errors['minlength']
      "
    >
      Mínimo de
      {{ form.controls['buttonText'].errors['minlength']['requiredLength'] }}
      caracteres
    </small>
  </span>
  <span class="p-float-label">
    <p-dropdown
      [options]="iconOptions"
      formControlName="iconURL"
      [showClear]="false"
      placeholder="Selecione um ícone"
      appendTo="body"
    >
      <ng-template let-selected pTemplate="selectedItem">
        <div class="dropdown-item" *ngIf="form.value.iconURL">
          <img [src]="form.value.iconURL" alt="icon" />
          {{ imageName(form.value.iconURL) }}
        </div>
        <span *ngIf="!form.value.iconURL">Selecione um ícone</span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="dropdown-item">
          <img [src]="option" alt="icon" />
          {{ imageName(option) }}
        </div>
      </ng-template>
    </p-dropdown>
    <label for="iconURL">Ícone do modal</label>
  </span>
  <div class="buttons">
    <p-button
      *ngIf="permission"
      label="Salvar"
      type="submit"
      [disabled]="!form.valid"
    />
  </div>
</form>
<p-toast />
